export const obtenerInfoGeneral = async () => {
  try {
    const response = await fetch('/data/AS510B/infoGeneral.json', {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    
    const jsonData = await response.json();
    return jsonData;
  } catch (error) {
    console.error("Al hacer el fetching en data por el json", error);
    return [];
  }
}

export const obtenerInfoGeneral_SC250 = async () => {
  try {
    const response = await fetch('/data/SC250/infoGeneral.json', {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    
    const jsonData = await response.json();
    return jsonData;
  } catch (error) {
    console.error("Al hacer el fetching en data por el json", error);
    return [];
  }
}

export const obtenerInfoGeneral_AS710R = async () => {
  try {
    const response = await fetch('/data/AS710R/infoGeneral.json', {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    
    const jsonData = await response.json();
    return jsonData;
  } catch (error) {
    console.error("Al hacer el fetching en data por el json", error);
    return [];
  }
}

export const obtenerInfoGeneral_ROS1300 = async () => {
  try {
    const response = await fetch('/data/ROS1300/infoGeneral.json', {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    
    const jsonData = await response.json();
    return jsonData;
  } catch (error) {
    console.error("Al hacer el fetching en data por el json", error);
    return [];
  }
}

export const obtenerInfoGeneral_AS4325 = async () => {
  try {
    const response = await fetch('/data/AS4325/infoGeneral.json', {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    
    const jsonData = await response.json();
    return jsonData;
  } catch (error) {
    console.error("Al hacer el fetching en data por el json", error);
    return [];
  }
}

export const obtenerInfoGeneral_AS1050R = async () => {
  try {
    const response = await fetch('/data/AS1050R/infoGeneral.json', {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    
    const jsonData = await response.json();
    return jsonData;
  } catch (error) {
    console.error("Al hacer el fetching en data por el json", error);
    return [];
  }
}

export const obtenerInfoGeneral_AS530R = async () => {
  try {
    const response = await fetch('/data/AS530R/infoGeneral.json', {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    
    const jsonData = await response.json();
    return jsonData;
  } catch (error) {
    console.error("Al hacer el fetching en data por el json", error);
    return [];
  }
}